export default "__VITE_ASSET__fOPohQ_7__"